module.exports = __webpack_public_path__ + "img/soft-grove-kitchen-3.332068e7.jpeg";